import { render, staticRenderFns } from "./dialog-tongzhuren-list.vue?vue&type=template&id=2bd12166&scoped=true&"
import script from "./dialog-tongzhuren-list.vue?vue&type=script&lang=js&"
export * from "./dialog-tongzhuren-list.vue?vue&type=script&lang=js&"
import style0 from "./dialog-tongzhuren-list.vue?vue&type=style&index=0&id=2bd12166&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd12166",
  null
  
)

export default component.exports